import { ISearch } from '@/models/search'
import { SearchService } from '@/service/searchService'
import { reactive } from 'vue'
import { ChannelState } from './channels'
import { GroupState } from './groups'

class ISearchState {
  state = reactive({
    fetching: false,
    error: null as any,
    searchDiscussionResults: [] as ISearch[],
    isLastPage: false,
  })

  async fetchSearchDiscussionResults(
    query: string,
    token?: string,
    channelSlug?: string
  ) {
    try {
      if (!query || this.state.fetching || this.state.isLastPage) {
        return this.state.searchDiscussionResults
      }

      this.state.fetching = true
      this.state.error = null
      let data
      if (channelSlug) {
        if (!GroupState.state.channelList) {
          await ChannelState?.fetchChannels(true)
        }
        const channel = (GroupState.state.channelList ?? []).find(
          (channel: any) => channel.slug === channelSlug
        )
        const channelId = channel?._id

        data = await SearchService.getSearchDiscussionResultsByChannel(
          query,
          { token: token },
          channelId
        )
      } else {
        data = await SearchService.getSearchDiscussionResults(query, {
          token: token,
        })
      }
      if (data.length === 0) {
        this.state.isLastPage = true
      }
      this.state.searchDiscussionResults = [
        ...this.state.searchDiscussionResults,
        ...data,
      ]
      return this.state.searchDiscussionResults
    } catch (error: any) {
      this.state.error = error?.response?.message || 'Something went wrong'
      console.error(error)
      throw error
    } finally {
      this.state.fetching = false
    }
  }
}

export const SearchState = new ISearchState()
